/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_Export_OwnInputs */

const cs_settings_calendar_export_own = /** @type {(inputs: Settings_Calendar_Export_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportovat moje úkoly ve výchozím stavu`)
};

const en_settings_calendar_export_own = /** @type {(inputs: Settings_Calendar_Export_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export my tasks by default`)
};

/**
* | output |
* | --- |
* | "Export my tasks by default" |
*
* @param {Settings_Calendar_Export_OwnInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_export_own = /** @type {((inputs?: Settings_Calendar_Export_OwnInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_Export_OwnInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_export_own(inputs)
	return cs_settings_calendar_export_own(inputs)
});